<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/RTyyqn/tc-custom/9781615954155.jpg?1732163509453" alt="This image is the cover for the book Hidden Heritage, Lottie Albright Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hidden Heritage, Lottie Albright Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p>After a gruesome killing at the Carlton County, Kansas, livestock feedyard, Sheriff Sam Abbot, Undersheriff Lottie Albright, and her ranching husband deputy know their resources are over-stretched. Still, none of their team or neighboring law enforcement in Western Kansas welcomes the idea of a regional crime center.</p><p>Kansas Bureau of Investigation Agent Dimon suggests the murder may not be a simple local affair. Unconvinced, Lottie— still director of the historical society—calls for stories from families whose ancestors were part of groups colonizing Kansas. Doña Francisca Díaz is the ancient head of one such clan.</p><p>It turns out, Francisca's great grandson Victor was the murder victim. Francisca, a fabled curandera with terribly damaged hands, insists she knows why Victor was killed. The key, she claims, is in ancient documents.</p><p>At Doña Francisca's invitation, Lottie visits the Díaz' property. In a drought-ridden area, the land is lush. Francisca wants Lottie to train as her heir. Reluctant yet fascinated, Lottie agrees.</p><p>Will Lottie be lost in this maze of magic? Does this family and its secret hold the key to murder and other terrible crimes?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charlotte Hinger
      </h2>
      
      <p class="authorDescription body article"><P>Charlotte Hinger is an award-winning novelist and Kansas historian. The first book in her Lottie Albright series, Deadly Descent, won the AZ Book Publishers’ Award, Best Mystery/Suspense. Hidden Heritage won Kirkus Reviews 100 Best Mysteries & 100 Best Fiction Books of 2013. Fractured Families was a finalist for the Colorado Book Award. Charlotte lives in Colorado.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Poisoned Pen Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e54082a2